const data = {
  counterText: '名额有限',
  loading: '載入中',
  next: '下一页',
  previous: '以前',
  smCounterText: '名额有限',
};

export default data;
